import { render, staticRenderFns } from "./ListContacts.vue?vue&type=template&id=25c4de95"
import script from "./ListContacts.vue?vue&type=script&lang=js"
export * from "./ListContacts.vue?vue&type=script&lang=js"
import style0 from "./ListContacts.vue?vue&type=style&index=0&id=25c4de95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports